export default "__VITE_ASSET__e6ce1a72__"